export default __webpack_public_path__ + "static/media/binary-coding.60fafc2a.jpeg";